import type {CategorySerializer} from "@/generated/DjangoTypes";
import clsxm from "@/lib/clsxm";
import type {FC} from "react";

const InterestChip: FC<{
  category: CategorySerializer;
  className?: string;
  dataTestId?: string;
  isDisabled?: boolean;
  isSelected: boolean;
  onClick(): void;
}> = ({category, className, dataTestId, isDisabled, isSelected, onClick}) => (
  <button
    className={clsxm(
      "relative isolate flex h-10 items-center justify-center rounded-md border-3 p-2 disabled:cursor-not-allowed",
      isSelected ? "text-primary-dark-solid font-medium shadow-none" : "text-white",
      className,
    )}
    data-testid={dataTestId}
    disabled={isDisabled}
    onClick={onClick}
    type="button">
    <span className="z-20 whitespace-nowrap">{category.name}</span>
    {!isSelected && (
      <>
        <img
          alt=""
          className="absolute z-0 h-full w-full object-cover"
          loading="lazy"
          src={(category.image640 ?? category.image)!}
        />
        <div className="bg-neutral-grey-dark absolute z-10 h-full w-full opacity-50" />
      </>
    )}
  </button>
);

export default InterestChip;
